import { Component, Input, Output, EventEmitter, OnInit } from "@angular/core";
import Enumerable from "linq";
import { Customer } from "../../models";
import { RemoveSpecialCharacters } from "../../app/remove-special-characters";

@Component({
  selector: "agenda",
  templateUrl: "agenda.html",
})
export class AgendaComponent implements OnInit {
  public alphabet: Array<string> = ["All"];
  public ready = false;
  public removeSpecialCharacters: RemoveSpecialCharacters =
    new RemoveSpecialCharacters();

  @Input() show = false;
  @Input() set list(value: Array<Customer>) {
    if (!this.ready && value.length) {
      this.alphabet.push(
        ...Enumerable.from(value)
          .select((customer) =>
            this.removeSpecialCharacters.removeDiacritics(
              customer.company.charAt(0).toUpperCase()
            )
          )
          .distinct()
          .orderBy((s) => s)
          .toArray()
      );

      if (this.alphabet.length > 0) {
        this.highlight = this.alphabet[0];
      }
      this.ready = true;
    }
  }

  @Input() highlight: string;
  @Output() onSelect: EventEmitter<string> = new EventEmitter<string>();
  @Output() showState: EventEmitter<boolean> = new EventEmitter<boolean>();

  constructor() {}

  ngOnInit(): void {
    this.highlight = "All";
  }

  selectLetter(letter: string): void {
    this.highlight = letter;
    this.showState.emit(false);
    this.onSelect.emit(letter);
  }
}



// WEBPACK FOOTER //
// ./src/components/agenda/agenda.ts